import React from "react";
import { IconArrowUp, IconArrowDown } from "./Icons";
import styles from "./UI.module.css";

export function Button({ variant = "primary", children, ...rest }) {
  return (
    <button className={`${styles.btn} ${styles[variant]}`} {...rest}>
      {children}
    </button>
  );
}

export function Card({ title, action, children, className = "" }) {
  return (
    <div className={`${styles.card} ${className}`}>
      {(title || action) && (
        <div className={styles.cardHead}>
          {title && <h3>{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function KpiCard({ label, value, sub, delta, accent }) {
  const positive = delta > 0;
  const negative = delta < 0;
  return (
    <div className={styles.kpi}>
      <div className={styles.kpiLabel}>{label}</div>
      <div className={styles.kpiValue} style={accent ? { color: accent } : undefined}>
        {value}
      </div>
      {sub && <div className={styles.kpiSub}>{sub}</div>}
      {delta !== undefined && delta !== null && (
        <div
          className={`${styles.kpiDelta} ${positive ? styles.up : negative ? styles.down : ""}`}
        >
          {positive && <IconArrowUp width={13} height={13} />}
          {negative && <IconArrowDown width={13} height={13} />}
          {typeof delta === "string" ? delta : ""}
        </div>
      )}
    </div>
  );
}

export function Loading({ text = "Загрузка…" }) {
  return <div className={styles.loading}>{text}</div>;
}

export function EmptyState({ text }) {
  return <div className={styles.empty}>{text}</div>;
}

export function SourceBadge({ method }) {
  const measured = method === "measured";
  return (
    <span className={`${styles.badge} ${measured ? styles.measured : styles.proxy}`}>
      {measured ? "измерено" : "прокси"}
    </span>
  );
}
